<template>
  <div class="main-layout">
    <div class="scroll-navigation">
      <div
        class="nav-button"
        v-for="(item, index) in mainSections"
        :key="index"
        @click="scrollToSection(index + 1)"
        :class="{ active: index + 1 === activeSectionIndex }"
      >

        <span
          class="vhp-text white"
          :class="{ hide: activeSectionIndex === 1 }"
          >{{ item }}</span
        >
        <button></button>

      </div>
    </div>

    <div class="main-section vh" ref="mainSection" data-aos="fade">
      <div class="main-background">
        <div class="overlay"></div>
        <img
          v-if="prevSlideIndex >= 0 && mainContents[prevSlideIndex].url"
          :src="mainContents[prevSlideIndex].url"
          alt="home-image"
          class="home-image prev"
          :key="prevSlideIndex"
        />
        <img
          :src="
            mainContents[activeSlideIndex].url ||
            '@/assets/image/background/home1.jpg'
          "
          alt="home-image"
          class="home-image"
          :class="{ active: prevSlideIndex >= 0 }"
          :key="activeSlideIndex"
        />
      </div>
      <div class="section-wrap container-width full vh">
        <div class="section left">
          <div class="home-banner px-2 mt-8 mb-32">
            <div
              class="main-title"
              data-aos="fade-up"
              data-aos-duration="500"
              data-aos-delay="300"
              :key="activeSlideIndex"
            >
              {{ mainContents[activeSlideIndex].title || $t("메인타이틀") }}
            </div>
            <div
              class="main-description vhp-text xlarge light white"
              style="letter-spacing: 0"
              data-aos="fade-up"
              data-aos-duration="500"
              data-aos-delay="600"
              :key="activeSlideIndex"
            >
              {{ mainContents[activeSlideIndex].subtitle || $t("메인타이틀_설명") }}
            </div>

           
            <div class="main-slide-button-wrap">
       
              <div class="slide-button prev" @click="prevSlide">
                <span />
                <span />
              </div>

              <div class="slide-button next" @click="nextSlide">
                <span />
                <span />
              </div>

              <div class="slide-sequence">
                <span
                  v-for="n in mainContents.length"
                  :key="'sequence-' + n"
                  :class="
                    n - 1 <= activeSlideIndex && n - 1 >= activeSlideIndex
                      ? 'active'
                      : ''
                  "
                  @click="
                    (prevSlideIndex = activeSectionIndex),
                      (activeSlideIndex = n - 1)
                  "
                >
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
<!-- 
      <div
        style="
          position: absolute;
          bottom: 50px;
          left: 50%;
          transform: translateX(-50%);
          opacity: 0.9;
          display: flex;
          z-index: 10;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          style="
            opacity: 0.7;
            border: 1px solid #fff;
            width: 24px;
            height: 48px;
            border-radius: 1rem;
            cursor: pointer;
          "
          @click="scrollToSection(2)"
        >
          <div
            style="
              margin: auto;
              margin-top: 6px;
              border-radius: 100%;
              width: 4px;
              height: 4px;
              background-color: #fff;
              animation-name: scroll_down;
              animation-delay: 1s;
              animation-duration: 2s;
              animation-fill-mode: forwards;
              animation-iteration-count: infinite;
            "
          ></div>
        </div>
        <div class="vhp-text white xxsmall light my-2">
          SCROLL
        </div>
      </div> -->
    </div>

    <div class="main-section unlimited" ref="mainSection" data-aos="fade-up">
      <div class="section-wrap container-width full">
        <div class="section center">
          <div class="section-title">
            <div class="sub-title">
              <div class="vhp-text medium red bold">ABOUT US</div>
              <div class="sub-title"></div>
            </div>
          </div>
          <div class="section-content">
            <div class="row">
              <div class="vhp-text large">
                <span v-if="$i18n.locale === 'en'">
                  VAZIL Company predicts and carries out transportation, installation, and inspection on its own.
                  <span class="vhp-text large bold underline"
                    >Artificial intelligence robot automation platform company</span
                  >. <br />
                  Experience a customized AI robot factory tailored to various industrial sites. 
                  <br/>manufacturing
                  We provide artificial intelligence solutions needed for industry.
                </span>
                <span v-else>
                  바질컴퍼니는 스스로 예측하고 운반, 설치, 검사를 수행하는
                  <span class="vhp-text large bold underline"
                    >인공지능 로봇 자동화 플랫폼 기업</span
                  >입니다. <br />
                  다양한 산업 현장에 맞는 맞춤형 AI 로봇 공장을 경험하세요. 제조
                  산업에 필요한 인공지능 솔루션을 제공합니다.
                </span>
                
              </div>
            </div>

            <div class="row my-4 pt-2" data-aos="fade-up">
              <div class="box-container">
                <div
                  v-for="(item, idx) in businessInfo"
                  :key="idx"
                  data-aos-duration="500"
                  :data-aos-delay="idx * 200"
                  data-aos-offset="100"
                  data-aos="fade-right"
                  data-aos-easing="ease-in-out"
                  style="display: flex; align-items: center"
                  class="box"
                >
                  <div
                    v-if="idx === 1 || idx === 2"
                    class="transparent icon-wrap"
                  >
                    <div
                      v-if="idx === 1"
                      class="vhp-text xxlarge"
                      style="font-family: 'Pretendard-ExtraLight'"
                    >
                      ＋
                    </div>
                    <div v-if="idx === 2" class="vhp-text xlarge light">→</div>
                  </div>
                  <div
                    class="outline round small pa-4 ma-4"
                    v-if="idx === 0 || idx === 1 || idx === 2"
                  >
                    <div class="round-wrap">
                      <div>
                        <strong class="vhp-text medium bold">
                          {{ $t(item.title) }}
                        </strong>
                      </div>
                      <div class="box-content mt-4">
                        <img :src="item.image" height="70" />
                        <div
                          class="vhp-text mt-2 mx-2"
                        >
                          {{ $t(item.description) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row ">
              <button
                class="vhp-action-button light"
                @click="$router.push('/info')"
              >
                {{ $t("자세히") }}

              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-section" ref="mainSection">
      <div class="main-background">
        <div class="overlay"></div>
        <img
          src="@/assets/image/background/bg37.jpg"
          alt="home-image"
          class="home-image prev"
        />
      </div>
      <div class="section-wrap container-width full">
        <div class="section center">
          <div class="section-title" 
            data-aos="fade-up"
          >
            <div class="vhp-text bold gray">PRODUCTS</div>
            <div class="sub-title" style="color: rgba(255, 255, 255, 0.9)">
              {{ $t("제품") }}
            </div>
          </div>
          <div class="section-content"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div class="row">
              <div class="slide-wrap my-4">
                <vhp-simple-slide
                  :items="solutionContents"
                  :show-count="4"
                  @click:item="(item, index) => $router.push('/products?index=' + index)"
                />
              </div>
            </div>
            <div class="row ">
              <button
                class="vhp-action-button"
                @click="$router.push('/products')"
              >
                {{ $t("목록보기") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="true" class="main-section" ref="mainSection">
      <div class="section-wrap container-width full">
        <div class="section center">
          <div class="section-title"
            data-aos="fade-up"
          >
            <div class="vhp-text bold navy">TECHNOLOGY</div>
            <div class="sub-title">{{$t('기술')}}</div>
          </div>
          <div class="section-content"
            
            data-aos="fade-up"
            data-aos-delay="200"
          
          >
            <div class="row">
              <div class="slide-wrap my-4">
                <vhp-simple-slide
                  :items="technologyContents"
                  :show-count="4"
                  class="service-slide"
                  @click:item="$router.push('/technology')"
                />
              </div>
            </div>
            <div class="row">
              <div
                class="vhp-action-button light outline"
                @click="$router.push('/technology')"
              >
                {{ $t("상세보기") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-section" ref="mainSection">
      <div v-if="true" class="main-background">
        <div
          class="color"
          style="
            background: #f5f6fa;
            background: linear-gradient(
              90deg,
              rgba(245, 246, 250, 0.5),
              rgba(234, 235, 253, 0.3)
            );
          "
        ></div>
      </div>
      <div class="section-wrap container-width full">
        <div class="section center">
          <div class="section-title"
            data-aos="fade-up"
          >
            <div class="vhp-text pink bold">NEWS</div>
            <div class="sub-title">{{ $t("소식") }}</div>
          </div>
          <div class="section-content"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div class="row mt-2" v-if="!loadingContents">
              <div class="slide-wrap">
                <vhp-card-slide
                  :items="storyContents.slice(0, 6)"
                  :show-count="3"
                  :base-url="'/news/details'"
                  :list-url="'/news'"
                  @click:item="(item, index) => $router.push('/news/details?id=' + item.id)"
                />
              </div>
            </div>
            <div class="row">
              <div class="vhp-action-button light outline" @click="$router.push('/news')">
                {{ $t('바로가기') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-section unlimited" ref="mainSection">
      <div class="section-wrap container-width full">
        <div class="main-background">
          <div class="overlay"></div>
          <img
            src="@/assets/image/background/bg37.jpg"
            alt="home-image"
            class="home-image"
          />
        </div>
        <div class="section center" style="padding: 35px 0">
          <div class="mt-16 pt-4 pb-8"
             data-aos="fade-up"
          >
            <div class="vhp-text large white mt-2">
              {{ $t("메인콘텐츠5_설명") }}<br />
              {{ $t("메인콘텐츠5_부가설명") }}<br />
            </div>
            <button class="vhp-action-button" @click="$router.push('/contact')">
              {{ $t("문의하기") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeLayout",
  components: {},
  data() {
    return {
      mainSections: [
        "MAIN",
        "ABOUT US",
        "PRODUCTS",
        "TECHNOLOGY",
        "NEWS",
        "CONTACT",
      ],
      mainSectionCount: 0,
      activeSectionIndex: 1,

      bannerMessage: "",
      bannerMessageInterval: null,
      typing: true,

      videoUrls: [
        "https://www.youtube.com/embed/g6vl5RRQAco?si=Jhp3m2xTCfXlG3pi",
        "https://www.youtube.com/embed/hu03pSgNFsQ?si=nVhUaZIGwgdr9D15",
      ],

      loadingContents: false,
      loadingProducts: false,
      viewLimit: 3,
      storyContents: [],

      solutionContents: [
        {
          id: "@content-ts2ggs9s8j79",
          title: this.$t("자동화 솔루션"),
          subtitle: "solution description",
          image: require("@/assets/image/main/automation.jpg"),
        },
        {
          id: "@content-1iepgkj24u2bb",
          title: this.$t("로봇 솔루션"),
          subtitle: "solution description",
          image: require("@/assets/image/main/robot_solution.jpg"),
        },
        {
          id: "@content-qy4y6lfq53ch",
          title: this.$t("통합 S/W 솔루션"),
          subtitle: "solution description",
          image: require("@/assets/image/background/home5.jpg"),
        },
        {
          id: "@content-ts2ggs9s8j79",
          title: this.$t("AI 통합 솔루션"),
          subtitle: "solution description",
          image: require("@/assets/image/main/integration_solution.jpg"),
        },
      ],

      technologyContents: [
        {
          title: "ROBOT",
          subtitle: "technology description",
          image: require("@/assets/image/main/robot.gif"),
        },
        {
          title: "AI",
          subtitle: "technology description",
          image: require("@/assets/image/tech/tech26.gif"),
        },
        {
          title: "3D & 2D VISION",
          subtitle: "technology description",
          image: require("@/assets/image/tech/tech14.jpg"),
        },
        {
          title: "DIGITAL TWIN",
          subtitle: "technology description",
          image: require("@/assets/image/main/twin.jpg"),
        },
        {
          title: "CLOUD",
          subtitle: "technology description",
          image: require("@/assets/image/main/cloud.jpg"),
        },
        
      ],

      products: [],
      businessInfo: [
        {
          name: "ROBOT",
          title: "로봇 사업부",
          description: "빈 피킹 / 핸들링 / 디버링 / 용접로봇 / 비전검사",
          image: require("@/assets/image/pictogram/robot1.png"),
        },
        {
          name: "SOLUTION",
          title: "솔루션 사업부",
          description: "인공지능 통합 플랫폼 / 로봇 통합 관제 시스템",
          image: require("@/assets/image/pictogram/solution4.png"),
        },
        {
          name: "SMART FACTORY",
          title: "공정 자동화 솔루션",
          description: "스마트팩토리 / 맞춤형 AI 자율형 공장",
          image: require("@/assets/image/pictogram/factory1.png"),
        },
      ],

      mainContents: [
        {
          url: require("@/assets/image/background/home7.jpg"),
          type: "image",
          title: this.$t('메인타이틀7'),
          subtitle: this.$t('메인타이틀7_설명')      
        },
        {
          url: require("@/assets/image/background/home3.jpg"),
          type: "image",
          title: this.$t('메인타이틀3'),
          subtitle: this.$t('메인타이틀3_설명')      
        },
        {
          url: require("@/assets/image/background/home5.jpg"),
          type: "image",
          title: this.$t('메인타이틀'),
          subtitle: this.$t('메인타이틀_설명')
        },
        {
          url: require("@/assets/image/background/home4.jpg"),
          type: "image",
          title: this.$t('메인타이틀2'),
          subtitle: this.$t('메인타이틀2_설명')        
        },
      ],
      activeSlideIndex: 0,
      prevSlideIndex: -1,
      slideIntervalTime: 0
    };
  },
  creted() {},
  mounted() {
    setInterval(() => {
      if(this.slideIntervalTime > 5000) {
        this.nextSlide();
      }
      this.slideIntervalTime += 1000
    }, 1000);

    window.addEventListener("scroll", this.scrollEvent);

    this.getContents();
    this.getProducts();
  },
  unmounted() {
    window.removeEventListener("scroll", this.scrollEvent);
  },
  watch: {},
  computed: {},
  methods: {
    prevSlide() {
      this.prevSlideIndex = this.activeSlideIndex;
      this.activeSlideIndex =
        this.activeSlideIndex > 0
          ? this.activeSlideIndex - 1
          : this.mainContents.length - 1;
    },

    nextSlide() {
      this.prevSlideIndex = this.activeSlideIndex;
      this.activeSlideIndex =
        this.activeSlideIndex >= this.mainContents.length - 1
          ? 0
          : this.activeSlideIndex + 1;
      
      this.slideIntervalTime = 0
    },

    scrollTop() {
      window.scroll({
        behavior: "smooth",
        left: 0,
        top: 0,
      });
    },

    scrollEvent() {
      const scrollPosition = window.scrollY;

      const sections = document.querySelectorAll(".main-section");
      let minDistance = Infinity;
      let activeIndex = null;

      sections.forEach((section, index) => {
        const distance = Math.abs(scrollPosition - section.offsetTop);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index + 1;
        }
      });

      this.activeSectionIndex = activeIndex;
    },

    scrollToSection(index) {
      const targetSection =
        document.querySelectorAll(".main-section")[index - 1];

      if (targetSection) {
        window.scrollTo({
          top: targetSection.offsetTop - 70,
          behavior: "smooth",
        });
      }
    },

    drawBackground() {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = window.innerWidth;
      canvas.height =window.innerHeight;

      ctx.font =
        "32px bold Apple SD Gothic Neo, Pretendard-Regular, NotoSansKR, sans-serif ";
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#C4182804";
      ctx.beginPath();
      ctx.moveTo(canvas.width, 0);
      ctx.lineTo(canvas.width * 0.7, 0);
      ctx.lineTo(canvas.width, canvas.height * 0.8);
      ctx.fill();

      ctx.fillStyle = "#C4182803";
      ctx.beginPath();
      ctx.moveTo(canvas.width, canvas.height);
      ctx.lineTo(canvas.width * 0.7, canvas.height);
      ctx.lineTo(canvas.width, canvas.height * 0.5);
      ctx.fill();

      ctx.fillStyle = "#C4182803";
      ctx.beginPath();
      ctx.moveTo(0, canvas.height);
      ctx.lineTo(canvas.width * 0.3, 0);
      ctx.lineTo(0, canvas.height * 0.2);
      ctx.fill();

      ctx.fillStyle = "#C4182802";
      ctx.beginPath();
      ctx.moveTo(0, canvas.height);
      ctx.lineTo(canvas.width * 0.3, canvas.height);
      ctx.lineTo(0, canvas.height * 0.5);
      ctx.fill();

      let src = canvas.toDataURL("image/png", 1.0);
      document.body.style.backgroundImage = "url(" + src + ")";
    },

    async getContents() {
      this.loadingContents = true;
      await this.$axios
        .get(
          "/content?category=NOTICE&category=SERVICE&category=STORY&category=PEOPLE&locale=" +
            this.$i18n.locale.toUpperCase()
        )
        .then((res) => {
          this.storyContents = [];

          let contents = res.data.filter((e) => !e.hidden && e.image);
          for (let i = 0; i < contents.length; i++) {
            if (
              contents[i].category === "NOTICE" ||
              contents[i].category === "STORY"
            ) {
              this.storyContents.push(contents[i]);
            }
          }
        });
      this.loadingContents = false;
    },

    async getProducts() {
      this.loadingProducts = true;

      await this.$axios
        .get("/product")
        .then((res) => {
          this.products = res.data;
        })
        .catch((err) => {
          console.log(err);
        });

      this.loadingProducts = false;
    },

    onClickCard(item) {
      if (item.isExternalLink) {
        this.$utils.openLink(item.externalUrl);
      } else {
        this.$router.push("/news/details?id=" + item.id + "&list=/news");
      }
    },

    onClickServiceCard(item) {
      if (!item.id) {
        this.$router.push("/preparation");
      } else if (item.isExternalLink) {
        this.$utils.openLink(item.externalUrl);
      } else {
        this.$router.push("/content?id=" + item.id + "&list=/service");
      }
    },
  },
};
</script>

<style lang="scss" src="./MainLayout.scss"></style>
